import { useState } from "react";
import AccountsAPI from "../../lib/API/AccountsAPI";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";

const ResetPassword = () => {

    const query = new URLSearchParams(useLocation().search);
    const token = query.get('token');
    const id = query.get('id');
    
    const [email, setEmail] = useState();
    const [sending, setSending] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const [request, setRequest] = useState({
        password : null,
        confirm : null
    });
    const [resetting, setResetting] = useState(false);
    const [passwordReset, setPasswordReset] = useState(false);


    const [resetFailed, setResetFailed] = useState(false);

    const onEmailChange = ({ target }) => {
        setEmail(target.value);
    }
    
    const onPasswordChange = ({ target }) => {
        setRequest({ ...request, [target.name] : target.value});
    }

    const onRequestSubmit = (e) => {
        e.preventDefault();
        setSending(true);
        setResetFailed(false);
        AccountsAPI.requestPasswordReset(email)
            .then(() => {
                setEmailSent(true);
                setSending(false);
            },
                () => {
                    setResetFailed(true);
                    setSending(false)
                });
    }
    
    const onResetSubmit = (e) => {
        e.preventDefault();
        setResetting(true);
        setResetFailed(false);
        AccountsAPI.resetPassword({ password : request.password, token, id })
            .then(() => {
                setPasswordReset(true);
                setResetting(false);
            },
                () => {
                    setResetFailed(true);
                    setResetting(false)
                });
    }

    return (token && id) ? (
        <>
            <div className="d-flex justify-content-center align-items-center fill-page" style={{ "min-height": "calc(100vh - 100px)" }}>
            {passwordReset ? (
                    <div className="alert alert-success alert-lg text-center">
                        <img className="alert-icon mb-3"  src={"/icons/check-circle.svg"} />
                        <p className="text-center mb-5">
                            Your password has been changed, you can now login with your new password
                        </p>
                        <Link to={'/'} className={"btn btn-black"}>Go to Homepage</Link>
                    </div>
                ) : (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 offset-md-3 offset-lg-3 col-md-6 col-lg-6 login-col">
                                <div className="h-100">
                                    <form className={"d-flex flex-column h-100"} onSubmit={onResetSubmit}>
                                        <div style={{ flex: 1 }}>
                                            <div className="login-header">Reset Password</div>
                                            {resetFailed ? (
                                                <div className="alert alert-danger text-center">
                                                    Something went wrong please retry.
                                                </div>
                                            ) : (
                                                <p className="mt-3 text-center">Enter your new password</p>
                                            )}
                                            <div className="form-group">
                                                <label for="email">New password</label>
                                                <input type="password" onChange={onPasswordChange} name="password" className="form-control" id="password" placeholder="Enter a strong password" />
                                            </div>
                                            <div className="form-group">
                                                <label for="email">Confirm your new password</label>
                                                <input type="password" onChange={onPasswordChange} name="confirm" className="form-control" id="confirm" placeholder="Enter a strong password" />
                                            </div>
                                        </div>
                                        <div className="btns">
                                            <button className="btn-yellow w-100" disabled={resetting}>Change Password</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    ) : (
        <>
        <div className="d-flex justify-content-center align-items-center fill-page" style={{ "min-height": "calc(100vh - 100px)" }}>
                {emailSent ? (
                    <div className="alert alert-success alert-lg text-center">
                        <img className="alert-icon mb-3"  src={"/icons/check-circle.svg"} />
                        <p className="text-center mb-5">
                            An email was sent to you at <b>{email}</b> containing the steps needed to reset your password
                        </p>
                        <Link to={'/'} className={"btn btn-black"}>Go to Homepage</Link>
                    </div>
                ) : (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 offset-md-3 offset-lg-3 col-md-6 col-lg-6 login-col">
                                <div className="h-100">
                                    <form className={"d-flex flex-column h-100"} onSubmit={onRequestSubmit}>
                                        <div style={{ flex: 1 }}>
                                            <div className="login-header">Reset Password</div>
                                            {resetFailed ? (
                                                <div className="alert alert-danger text-center">
                                                    This email is not assigned to any user, please verify your email
                                                </div>
                                            ) : (
                                                <p class="mt-3 text-center">An email will be sent to you conaining the steps to reset your password</p>
                                            )}
                                            <div className="form-group">
                                                <label for="email">Email</label>
                                                <input type="email" onChange={onEmailChange} name="email" className="form-control" id="email" placeholder="Enter your email" />
                                            </div>
                                        </div>
                                        <div className="btns">
                                            <button className="btn-yellow w-100" disabled={sending}>Send Email</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default ResetPassword;